export default "__VITE_ASSET__9ccc22ae__"